// extracted by mini-css-extract-plugin
export default {"annual-activities":"AnnualActivities_annual-activities__LtGP0"};